export const GET_COMPANY_ORDER = 'GET_COMPANY_ORDER'
export const GET_COMPANY_ORDER_SUCCESS = 'GET_COMPANY_ORDER_SUCCESS'
export const GET_COMPANY_ORDER_ERROR = 'GET_COMPANY_ORDER_ERROR'